import { createSlice } from "@reduxjs/toolkit";
import {
  viewTestimonials,
  singleTestimonials,
  registerTestimonials,
  updateTestimonials,
  deleteTestimonials,
} from "../actions/testimonialsAction";

const testimonialSlice = createSlice({
  name: "testimonials",
  initialState: {
    testimonials: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(updateTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(deleteTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(singleTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.testimonials = action.payload;
      })
      .addCase(registerTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(viewTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default testimonialSlice.reducer;
